// 判断是否在微信浏览器打开
// #ifdef  H5	
const browser = {
  versions: function() {
    var u = window.navigator.userAgent,
      app = window.navigator.appVersion;
    return { //移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1 ,//是否web应该程序，没有头部与底部
      inWeiXin: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger', // 是否在微信中打开
      isWxPublic: (!!u.match(/AppleWebKit.*Mobile.*/)) && (u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'), //在微信公众号打开
    };
  }(),
  language: (window.navigator.browserLanguage || window.navigator.language).toLowerCase()
}
// #endif
// 把对象转换成url参数
const makeQuery = function(queryObject) {
  console.log(queryObject);
  const query = Object.entries(queryObject)
    .reduce((result, entry) => {
      result.push(entry.join('='))
      return result
    }, []).join('&')
  return `?${query}`
}

// 比较一天内的两个时间段大小
const compareDate = function(t1, t2) {
  var date = new Date();
  var a = t1.split(":");
  var b = t2.split(":");
  return date.setHours(a[0], a[1]) > date.setHours(b[0], b[1]);
};
// 计算两个日期相差天数
const dateMinus = function(date1, date2) {
  //date1:小日期   date2:大日期
  var sdate = new Date(date1);
  var now = new Date(date2);
  var days = now.getTime() - sdate.getTime();
  var day = parseInt(days / (1000 * 60 * 60 * 24));
  return day;
};
/** 
 * 时间戳转化为年 月 日 时 分 秒 
 * number: 传入时间戳 
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致 
 */


const formatTime = function(number, format) {
  var formateArr = ['yyyy', 'MM', 'dd', 'hh', 'mm', 'ss'];
  var returnArr = [];
  var date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));
  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }

  return format;
}; //数据转化 


const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : '0' + n;
}; // 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符， 
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) 
// 例子： 
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423 
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18 


const format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1,
    //月份 
    "d+": this.getDate(),
    //日 
    "H+": this.getHours(),
    //小时 
    "m+": this.getMinutes(),
    //分 
    "s+": this.getSeconds(),
    //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3),
    //季度 
    "S": this.getMilliseconds() //毫秒 

  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));

  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k])
      .substr(("" + o[k]).length));

  return fmt;
};

const getDateStr = function(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期

  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取当前月份的日期

  var d = dd.getDate();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  return y + "-" + m + "-" + d;
}; // 前天：" + GetDateStr(-2);
// 昨天：" + GetDateStr(-1);
// 今天：" + GetDateStr(0);
// 明天：" + GetDateStr(1);
// 后天：" + GetDateStr(2);
// 大后天：" + GetDateStr(3);

/**
 * 格式化时间
 */


const formatDate = function(dateStr, dateType) {
  var DateStr = "";
  var date = new Date(dateStr);
  var month = (date.getMonth() + 1).toString();

  if (month.length == 1) {
    month = "0" + month;
  }

  var day = date.getDate().toString();

  if (day.length == 1) {
    day = "0" + day;
  }

  DateStr = date.getFullYear() + '-' + month + '-' + day;
  var min = date.getMinutes().toString();
  var hours = date.getHours().toString();
  var second = date.getSeconds().toString();

  if (dateType == '2') {
    if (hours.length == 1) {
      hours = "0" + hours;
    }

    if (min.length == 1) {
      min = "0" + min;
    }

    if (second.length == 1) {
      second = "0" + second;
    }

    DateStr += " " + hours + ":" + min + ":" + second;
  }

  if (dateType == '3') {
    DateStr = date.getFullYear() + '-' + month + '-' + day + " " + hours + ":" + min + ":" + second;
  }
  
  if(dateType == '4'){
	  DateStr = date.getFullYear() + '年' + month + '月' + day + "日";
  }

  if (day == 'NaN') {
    DateStr = "";
  }

  return DateStr;
};

const arrSort = function(prop) {
  return function(obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];

    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }

    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  };
};
//去除特殊字符
const filterSpecialStr = (str) => {
  var value = str.replace(/[\-\_\,\!\|\~\`\(\)\#\$\%\^\&\*\{\}\:\;\"\'\，\“\”\、\！\？\L\<\>\?]/g, '');
  return value;
}
/**
 * 身份证验证
 * @param {string}-card 身份证号码
 * @return {boolean}-true 验证通过，false 验证不通过
 */
const regIDCard = (card) => {
  const reg =
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  return reg.test(card);
}
/**
 * 手机号验证
 * @param {string}- phoneNum 
 * @return{boolean}- true 验证通过，false 验证不通过
 */
const regPhone = (phoneNum) => {
  const reg = new RegExp("^1[0-9][0-9]{9}$");

  return reg.test(phoneNum);
}
//过滤汉字
const removeChinese = (strValue) => {
  if (strValue != null && strValue != "") {
    var reg = /[\u4e00-\u9fa5]/g;
    return strValue.replace(reg, "");
  } else
    return "";
}
/**
 * 日期格式化
 * @param {几天内} num  
 */
const fun_date = (num) => {
  var date1 = new Date();
  //今天时间
  let month1 = date1.getMonth() + 1 + '';
  let day1 = date1.getDate() + '';
  if (month1.length == 1) {
    month1 = "0" + month1;
  }
  if (day1.length == 1) {
    day1 = "0" + day1;
  }
  console.log(month1);
  var time1 = date1.getFullYear() + "-" + month1 + "-" + day1;
  var date2 = new Date(date1);
  date2.setDate(date1.getDate() + num);
  let month2 = date2.getMonth() + 1 + '';
  let day2 = date2.getDate() + '';
  if (month2.length == 1) {
    month2 = "0" + month2;
  }
  if (day2.length == 1) {
    day2 = "0" + day2;
  }
  //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
  var time2 = date2.getFullYear() + "-" + month2 + "-" + day2;
  return [time1, time2];
}
/**
 * 日期格式化
 * @param {传入的日期} time 
 * @param {要转换的格式} cFormat 
 */
const parseTime = (time, cFormat) => {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time);
    }else if(typeof time === 'string'&&!(/^[0-9]+$/.test(time))){
      time = time.replace(/-/g, '/');
    }else if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}
/** 
 * 快捷获取时间
 * type: 今天/本周/本月/本年 
 */
const expressTime = (type) => {
  //获取当前时间
  //起止日期数组
  let startStop = new Array();
  //一天的毫秒数
  let millisecond = 1000 * 60 * 60 * 24;
  //获取当前时间
  let currentDate = new Date();
  if (type < 7) { // 获取今天/昨天/明天
    currentDate.setTime(currentDate.getTime() - millisecond * type);
    startStop.push(
      parseTime(
        currentDate.setHours(0, 0, 0, 0),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    startStop.push(
      parseTime(
        currentDate.setHours(23, 59, 59, 999),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    return startStop;
  } else if (type == 'T7') { //获取上周
    //起止日期数组
    let startStop = new Array();
    //返回date是一周中的某一天
    let week = currentDate.getDay();
    //减去的天数
    let minusDay = week != 0 ? week - 1 : 6;
    //获得当前周的第一天
    let currentWeekDayOne = new Date(currentDate.getTime() - (millisecond * minusDay));
    //上周最后一天即本周开始的前一天
    let priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond);
    //上周的第一天
    let priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6));

    startStop.push(
      parseTime(
        priorWeekFirstDay.setHours(0, 0, 0, 0),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    startStop.push(
      parseTime(
        priorWeekLastDay.setHours(23, 59, 59, 999),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    //返回
    return startStop;
  } else if (type == 7) { //获取本周
    //相对于当前日期AddWeekCount个周的日期
    currentDate = new Date(currentDate.getTime() + millisecond * 7 * 0);

    //返回date是一周中的某一天
    let week = currentDate.getDay();
    //返回date是一个月中的某一天
    let month = currentDate.getDate();
    //减去的天数
    let minusDay = week != 0 ? week - 1 : 6;
    //获得当前周的第一天
    let currentWeekFirstDay = new Date(
      currentDate.getTime() - millisecond * minusDay
    );
    //获得当前周的最后一天
    let currentWeekLastDay = new Date(
      currentWeekFirstDay.getTime() + millisecond * 6
    );
    //添加至数组
    startStop.push(
      parseTime(
        currentWeekFirstDay.setHours(0, 0, 0, 0),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    startStop.push(
      parseTime(
        currentWeekLastDay.setHours(23, 59, 59, 999),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    return startStop;
  } else if (type == 'T30') { // 获取上个月
    let startStop = new Array();
    //获得当前月份0-11
    let currentMonth = currentDate.getMonth();
    //获得当前年份4位年
    let currentYear = currentDate.getFullYear();
    let currentDay = new Date(currentYear, currentMonth, 1);
    //上个月的第一天
    //年份为0代表,是本年的第一月,所以不能减
    if (currentMonth == 0) {
      currentMonth = 11; //月份为上年的最后月份
      currentYear--; //年份减1
    } else {
      currentMonth--;
    }
    let firstDay = new Date(currentYear, currentMonth, 1);
    //求出上月的最后一天
    let lastDay = new Date(currentDay.getTime() - millisecond);
    startStop.push(
      parseTime(
        firstDay.setHours(0, 0, 0, 0),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    startStop.push(
      parseTime(
        lastDay.setHours(23, 59, 59, 999),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    return startStop;
  } else if (type == 30) { // 获取本月
    let monthFirstDay = new Date(currentDate.setDate(1));
    let currentMonth = currentDate.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(currentDate.getFullYear(), nextMonth, 1);
    let monthLastDay = new Date(nextMonthFirstDay - millisecond);
    startStop.push(
      parseTime(
        monthFirstDay.setHours(0, 0, 0, 0),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    )
    startStop.push(
      parseTime(
        monthLastDay.setHours(23, 59, 59, 999),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    return startStop;
  } else {
    let year = currentDate.getFullYear();
    let new_year = year; //取当前的年份
    let new_date = new Date(new_year, 0, 1); //取当年当月中的第一天
    let lastDate = new Date(new_year, 11, 31); //获取当月最后一天日期
    startStop.push(
      parseTime(new_date, "{y}-{m}-{d} {h}:{i}:{s}")
    )
    startStop.push(
      parseTime(
        lastDate.setHours(23, 59, 59, 999),
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
    );
    return startStop;
  }
}

/**
 * 获取对应codeName列表
 */
const getCodeName =(codename) =>  {
  let codeObjStr = uni.getStorageSync("codeObj");
  let codeObj = JSON.parse(codeObjStr);
  return codeObj[codename] || [];
}

/**
 * 获取code中的name
 * @param {*} codename codename
 * @param {*} codeKey 下拉框值key
 */
const getCodeNameStr =(codename, codeKeyStr) =>  {
  let codeObjStr = uni.getStorageSync("codeObj");
  let codeObj = JSON.parse(codeObjStr);
  let arr = codeObj[codename] || [];
  codeKeyStr = String(codeKeyStr)
  let codeKeyArr = codeKeyStr.split(',')
  let retArr = []
  codeKeyArr.forEach(element => {
    let thisArr = arr.filter((item) => {
      return item.codeKey == element;
    })
    let name = thisArr.length>0?thisArr[0].codeValue:'';
    retArr.push(name)
  });
  let retStr = retArr.join(',')
  return retStr || "";
}
/** 
 * 时间戳转化为年 月 日 时 分 秒 
 * number: 传入时间戳 
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致 
 */
const formatDateTime=(number, format) => {
  var formateArr = ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss'];
  var returnArr = [];

  var date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}
//计算两个时间之间的时间差 多少天时分秒
const intervalTime=(times) => {
  // var timestamp=new Date().getTime(); //计算当前时间戳
  // var timestamp = (Date.parse(new Date()))/1000;//计算当前时间戳 (毫秒级)
  //  var date1 = ""; //开始时间
  // if(timestamp<startTime){
  //     date1=startTime;
  // }else{
  //     date1 = timestamp; //开始时间
  // }
  // var date2 = endTime; //结束时间
  // var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
  var date3 =  times; //时间差的毫秒数
  //计算出相差天数
  var days = Math.floor(date3 / (24 * 3600 * 1000));
  //计算出小时数

  var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))+'';
  if (minutes.length == 1) {
    minutes = "0" + minutes;
  }
  //计算相差秒数

  var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)+'';
  if (seconds.length == 1) {
    seconds = "0" + seconds;
  }
  // console.log(days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒")
  return {
    d:days,
    h:hours,
    m:minutes,
    s:seconds,
  }
}
/**
 * 手机号码验证
 * @param {string}-value 手机号码
 * @return {boolean}-true 验证通过，false 验证不通过
 */
const regPhoneNumber = (value) => {
  const reg = /^1\d{10}$/;
  return reg.test(value);
}

const onBridgeReady = (data,resolve,reject) => {
  let that = this;
  console.log(WeixinJSBridge)
  if (typeof WeixinJSBridge == "undefined"){
     if( document.addEventListener ){
         document.addEventListener('WeixinJSBridgeReady', onBridge, false);
     }else if (document.attachEvent){
         document.attachEvent('WeixinJSBridgeReady', onBridge); 
         document.attachEvent('onWeixinJSBridgeReady', onBridge);
     }
  }else{
     onBridge();
  }
  function onBridge(){
  console.log(2222)
    WeixinJSBridge.invoke(
     'getBrandWCPayRequest', {
      "appId":data.appId,     //公众号名称，由商户传入     
      "timeStamp":data.timeStamp,//时间戳，自1970年以来的秒数     
      "nonceStr":data.nonceStr, //随机串     
      "package":data.package,     
      "signType":data.signType,  //微信签名方式：     
      "paySign":data.paySign //微信签名 
     },
     function(res){
     if(res.err_msg == "get_brand_wcpay_request:ok" ){
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        resolve();
     }else{
       toast.tip('支付失败');
       reject();
     }
    });
  }   
}
/**
 * 函数防抖
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
const debounce = (func, wait, immediate) => {
  let timeout, args, context, timestamp, result;
  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;
    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
  
}
/**
 * 获取当前位置坐标
 */
// const getCurLocation = () => {
//   let getLocation = promise.wxPromise(uni.getLocation);
//   return getLocation({
//       type: 'gcj02'
//     })
//     .then(res => {
//       return Promise.resolve({
//         latitude: res.latitude,
//         longitude: res.longitude
//       })
//     })
// }

  //计算两点之间距离
const distanceByLnglat = (lng1, lat1, lng2, lat2) => {
  var radLat1 = Rad(lat1);
  var radLat2 = Rad(lat2);
  var a = radLat1 - radLat2;
  var b = Rad(lng1) - Rad(lng2);
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378137.0; // 取WGS84标准参考椭球中的地球长半径(单位:m)
  s = Math.round(s * 10000) / 10000 / 1000;
  return s.toFixed(1);
}

const Rad = (d) => {
  return d * Math.PI / 180.0;
}

/**
 * 邮箱验证
 * @param {string}-card 邮箱
 * @return {boolean}-true 验证通过，false 验证不通过
 */
const regEml = (eml) => {
  const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
  return reg.test(eml);
}

export {
  // debounce:debounce,
  // makeQuery: makeQuery,
  // compareDate: compareDate,
  // dateMinus: dateMinus,
  // formatTime: formatTime,
  // parseTime: parseTime,
  // format: format,
  // getDateStr: getDateStr,
  // // countDown: countDown,
  // formatDate: formatDate,
  // arrSort: arrSort,
  // filterSpecialStr: filterSpecialStr,
  // regIDCard: regIDCard,
  // regPhone: regPhone,
  // removeChinese: removeChinese,
  // expressTime: expressTime,
  // fun_date: fun_date,
  // getCodeName:getCodeName,
  // formatDateTime:formatDateTime,
  regPhoneNumber,
  intervalTime,
  onBridgeReady,
  getCodeNameStr,
  distanceByLnglat,
	regEml
};
